import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { workersList, structureList } from './request';
import { postResource } from './../postManage/request';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  data() {
    return {
      filterText: '',
      postList: [],
      form: {
        structureId: 0,
        postId: undefined
      },
      data: [],
      //树结构
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      tableData: [],
      tableHead: [
        // {title: '序号',dataIndex: 'index',scopedSlots: {customRender: 'index'},width: 80,align: 'center'},
        // {title: '工号',  dataIndex: 'jobNo', key: '1',align: 'center'},
        // {title: '姓名',  dataIndex: 'name', key: '2',align: 'center'},
        // {title: '岗位',  dataIndex: 'postName', key: '3',align: 'center'},
        // {title: '人员状态',  dataIndex: 'statusName', key: '4',align: 'center'},
        // {title: '部门',  dataIndex: 'structureName', key: '5',align: 'center'},
        // {title: '操作',scopedSlots: {customRender: 'action'},align: 'center',width: 300,key: '6',fixed: 'right'}
      ],
      resourceList: []
    };
  },
  created() {
    console.log(JSON.stringify(this.tableHead));
    this.getStructure();
    this.getDataFun();
    this.getPostFun();
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getPostFun() {
      postResource({
        customerId: this.accountInfo.customerId
      }).then(res => {
        this.postList = res;
      });
    },
    getStructure() {
      structureList({
        customerId: this.accountInfo.customerId
      }).then(res => {
        this.data = res;
        this.$nextTick(() => {
          // 默认高亮选中节点
          this.$refs.tree.setCurrentKey(this.data[0].id);
        });
      });
    },
    handleNodeClick(data) {
      console.log(data);
      this.form.structureId = data.id;
      this.getDataFun();
    },
    async getDataFun() {
      const h = this.$createElement;
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      const res = await workersList(obj);
      if (res.fieldConfig) {
        this.tableHead = res.fieldConfig.map(item => {
          let obj = item;
          obj.slots = {
            title: item.title
          };
          obj.scopedSlots = {
            customRender: item.dataIndex
          };
          delete obj.title;
          if (item.ellipsis) {
            obj.customRender = text => h("a-tooltip", {
              "attrs": {
                "placement": "topLeft",
                "title": text
              }
            }, [text]);
          }
          return obj;
        });
        this.tableHead.push({
          slots: {
            title: '操作'
          },
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center',
          width: 300,
          key: '6',
          fixed: 'right'
        });
      }
      // .then(res=>{
      this.tableData = res.items || [];
      this.pagination.total = res.totalNum;
      // });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleAdd() {
      if (!this.form.structureId) {
        this.$message.error(this.$t('请选择') + this.$t('部门再进行新增操作'));
      } else {
        this.$router.push({
          name: 'staffInfoCustomer',
          params: {
            id: -1,
            type: -1,
            structure: this.form.structureId
          }
        });
      }
    }
  }
};